/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Report page
  Date: June 22, 2020
**/

import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  Grid,
  Tooltip,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography,
} from '@material-ui/core';
import AddBoxIcon from '@material-ui/icons/AddBox';
import BlockIcon from '@material-ui/icons/Block';
import {
  globalAssoSearchListingTypeEntity,
} from '../../constants/applicationConstants';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { stringConstants } from '../../constants/stringConstants';
import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    padding: '20px 0 0',
  },
  filterContainer: {
    padding: '30px 20px 10px 20px',
    fontSize: 20,
    fonWeight: 600,
  },
}));
import FilterSection from '../../components/filterSections/FilterSection';
import CustomListing from '../../components/customListing/CustomListing';
import { PopupModal, sortByField } from '../../submodule';
import { useHistory } from 'react-router-dom';
import { ReportForm } from './ReportForm';
const ReportPage = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const reportAction = useStoreActions((actions) => actions.report);
  const reportState = useStoreState((state) => state.report);
  const commonAction = useStoreActions((actions) => actions.common);
  const [openDelConfirmPopup, setOpenDelConfirmPopup] = useState(false);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectedDeleteRow, setSelectedDeleteRow] = useState({});
  const [tableData, setTableData] = useState([]);
  const [isAddReport, setIsAddReport] = useState(false);
  const [filteredData, setFlteredData] = useState({
    title: '',
    status: 'ALL',
    owner: 'ALL',
  });
  const searchByKeyworld = (key, value) => {
    setFlteredData({ ...filteredData, [key]: value });
  };

  function resetFilters() {
    setFlteredData({
      title: '',
      status: 'ALL',
      owner: 'ALL',
    })
  }
  const uniqueUser = reportState.customReportList.filter(item=> item.username).map(item=>item.username.username);
  const filterList = [
    {
      type: 'droupdown',
      title: 'Status',
      onChange: searchByKeyworld,
      value: filteredData.status,
      searchKey: 'status',
      list: ['ALL', 'Public', 'Private'],
    },
    {
      type: 'droupdown',
      title: 'Owner',
      onChange: searchByKeyworld,
      value: filteredData.owner,
      searchKey: 'owner',
      list: ['ALL',...new Set(uniqueUser)],
    },
  ];
  
  useEffect(() => {
    let newTableData = [...reportState.customReportList];
    newTableData = newTableData.filter((data) => {
      return (
        (data.visibility == filteredData.status ||
          filteredData.status == 'ALL') &&
        (filteredData.owner == 'ALL' ||
          filteredData.owner == data.username?.username) &&
        (filteredData.title == '' ||
          data.title
            .toLocaleLowerCase()
            .match(filteredData.title.toLocaleLowerCase()))
      );
    });
    
    newTableData = sortByField({
      data: newTableData,
      key: 'modify_date',
      secondKey: 'create_date',
    });
    setTableData(newTableData);
  }, [reportState.customReportList, filteredData]);

  const downloadReport = (event, filePath) => {
    event.preventDefault();
    if (filePath) {
      reportAction
        .getPreSignedUrl({
          filename: filePath,
          operation_type: 'DOWNLOAD',
        })
        .then(function (response) {
          window.open(response.data.data.url);
        })
        .catch(function (error) {
          commonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.fileDownloadFailureMsg,
            error: true,
          });
        });
    }
  };

  // load report list
  React.useEffect(() => {
    reportAction.setCustomReportListLoader(true);
    reportAction.setCustomReport(null);
    reportAction.getCustomReportList();
  }, []);


  const deleteVersionConfirmBox = (selectedRows) => {
    setSelectedDeleteRow(selectedRows);
    setOpenDelConfirmPopup(true);
  };

  //Delete Report
  const handleClose = (val) => {
    try {
      if (val === 'okay') {
        reportAction
          .deleteCustomReport({ reportId: selectedDeleteRow.PK })
          .then(function (response) {
            let filterDeleteCustomReport = reportState.customReportList.filter(
              (item) => item.PK !== selectedDeleteRow.PK,
            );
            reportAction.setCustomReportList(filterDeleteCustomReport);
            commonAction.setSubmitSnackbar({
              status: true,
              messages: stringConstants.dltAssociationMsg,
            });
          })
          .catch(function (error) {
            console.log('error', error);
          });
      }
      setSelectedDeleteRow({});
      setOpenDelConfirmPopup(false);
    } catch (err) {
      console.log('err', err);
    }
  };
  // Update Public Private Status
  const updatPublicPrivateStatus = (data, event) => {
    let reqData = {
      PK: data.PK,
      SK: data.SK,
      is_public: event.target.checked ? 'y' : 'n',
    };
    reportAction
      .updatPublicPrivateStatus(reqData)
      .then(function (response) {
        commonAction.setSubmitSnackbar({
          status: true,
          messages: stringConstants.updateMsg,
        });
      })
      .catch(function (error) {
        commonAction.setSubmitSnackbar({
          status: true,
          messages: 'Error updating the status',
          error: true,
        });
      });
  };

 const handleInlineStatusChange = ({ type, data, event }) => {
    switch (type) {
      case 'delete':
        deleteVersionConfirmBox(data);
        break;
      case 'download':
        downloadReport(event, data);
        break;
      case 'execute':
        reportAction.setReportresultList([]);
        history.push(
          `/reportresult/custom/${encodeURIComponent(data)}`,
        );
        break;
      case 'statusChange':
        updatPublicPrivateStatus(data, event);
        break;
      default:
        console.log('No Selection');
    }
  };

  return (
    <Grid container direction="row" style={{ backgroundColor: '#fff' }}>
      <Grid container direction="row">
        <Grid item md={12} xs={12}>
          <DisplayBreadcrumbs
            items={[
              { title: 'Reports', link: '' },
            ]}
          />
        </Grid>
        <Grid item md={12} className={classes.filterContainer}>
          <Grid container>
            <Grid item md={4} style={{ display: 'flex' }}>
              <Typography variant="h5"> Reports</Typography>
            </Grid>
            <FilterSection
              filterList={filterList}
              keywordsPlaceholder="Keyword"
              keywordskey="title"
              keywordsValue={filteredData.title}
              handleKeywordsChange={searchByKeyworld}
              resetFilters={resetFilters}
            />
            <Grid
              item
              md={4}
              
            >
              <Grid container alignItems="center" justifyContent="flex-end">
                <Tooltip title="Add New">
                  <IconButton
                    color="primary"
                    aria-label="Add"
                    onClick={() => setIsAddReport(true)}
                  >
                    <AddBoxIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Disable" style={{display:'none'}}>
                  <span>
                    <IconButton
                      onClick={() =>
                        activeDeactivateHandler(
                          event,
                          selectedItems,
                          globalPageTypeEntity.deactivate,
                        )
                      }
                      color="primary"
                      disabled={
                        selectedItems === null ||
                        (selectedItems && selectedItems.length === 0)
                      }
                    >
                      <BlockIcon />
                    </IconButton>
                  </span>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <CustomListing
          tableData={tableData}
          // isLoaded={isLoaded}
          entityType={globalAssoSearchListingTypeEntity.report_builder}
          handleInlineStatusChange={handleInlineStatusChange}
          // setShowModal={setShowModal}
          // setChangeIndex={setChangeIndex}
          setSelectedItems={setSelectedItems}
        />
        <Dialog
          maxWidth="md"
          open={openDelConfirmPopup}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          PaperProps={{
            style: { borderRadius: 20 },
          }}
        >
          <DialogTitle id="alert-dialog-slide-title">
            {'Delete - '+selectedDeleteRow.title}
          </DialogTitle>
          <DialogContent>

            <Grid container style={{ width: '500px', justifyContent:'center' }}>
              <DialogContentText id="alert-dialog-slide-description">
              Are you sure you want to delete this report?
              </DialogContentText>
            </Grid>
          </DialogContent>
          <DialogActions style={{ padding: '5px 35px 30px' }}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <Button
                  onClick={() => handleClose('cancel')}
                  variant="contained"
                  color="secondary"
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  onClick={() => handleClose('okay')}
                  variant="contained"
                  color="primary"
                >
                  Ok
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
        <PopupModal open={isAddReport} maxWidth="sm" isDirtyForm={false} >
            <ReportForm closePopup={()=>setIsAddReport(false)}/>
        </PopupModal>
      </Grid>
    </Grid>
  );
};

export default ReportPage;
